import axios from "axios";
import { apiURL, apiKey } from "../src/shared/env";

const axiosInstance = axios.create({
  // baseURL: "https://rckt-fe-dot-acn-cda.uc.r.appspot.com",
  // baseURL: "https://cloudrun-gateway-bemjkas6.nw.gateway.dev",
  baseURL: `${apiURL}`,
  headers: {
    apikey: apiKey,
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
